import ActivityFilled from '@crehana/icons/ActivityFilled';
import MessageSquare from '@crehana/icons/MessageSquareOutline';
import PlaySquareOutline from '@crehana/icons/PlaySquareOutline';
import { yellowMain } from '@crehana/ui/dist/styles/colors';

const Features = () => (
  <div className="w-full">
    <p className="font-subtitle1 mb-24">Transforma tu talento</p>
    <p className="font-body3 mb-24">
      Aprendizaje práctico para equipos más pequeños.
    </p>
    <div className="flex items-star mb-24">
      <div className="w-24 h-24 mr-12">
        <ActivityFilled size={24} color={yellowMain} />
      </div>
      <p className="font-body3">
        Acceso a todo el catálogo de Crehana para diseñar las rutas de
        aprendizaje.
      </p>
    </div>
    <div className="flex items-star mb-24">
      <div className="w-24 h-24 mr-12">
        <PlaySquareOutline size={24} color={yellowMain} />
      </div>
      <p className="font-body3">Analítica en tiempo real.</p>
    </div>
    <div className="flex items-star mb-24">
      <div className="w-24 h-24 mr-12">
        <MessageSquare size={24} color={yellowMain} />
      </div>
      <p className="font-body3">
        Acompañamiento de mentores expertos en la industria.
      </p>
    </div>
  </div>
);

export default Features;
